<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    append-to-body
    title="选择ESOP文件"
    width="800px"
    top="5vh"
  >
    <TableSelect :filter="filter" ref="tableSelect" :columns="columns" module="basic" url="esops" @select="selectESOP" @reset="resetHandle">
      <template slot="adSearch">
        <el-form :inline="true" ref="form" :model="filter">
          <el-form-item label="ESOP编号" prop="esopNo">
            <el-input v-model.trim="filter.esopNo" placeholder="请输入ESOP编号" clearable />
          </el-form-item>
          <el-form-item label="ESOP名称" prop="esopName">
            <el-input v-model.trim="filter.esopName" placeholder="请输入ESOP名称" clearable />
          </el-form-item>
        </el-form>
      </template>
    </TableSelect>
  </el-dialog>
</template>

<script>
import TableSelect from "@/components/TableSelect.vue";

export default {
  components: { TableSelect },
  data() {
    return {
      dialogVisible: false,
      filter: {
        esopNo: "",
        esopName: "",
      },
      columns: [
        {
          title: "ESOP编号",
          key: "esopNo",
          width: 100,
          align: "center",
        },
        {
          title: "ESOP名称",
          key: "esopName",
          minWidth: 150,
          tooltip: true,
        },
        {
          title: "操作",
          slot: "action",
          width: 80,
          align: "center",
        },
      ],
    };
  },
  methods: {
    open() {
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.form.resetFields();
        this.$refs.tableSelect.loadData();
      });
    },

    selectESOP(row) {
      this.dialogVisible = false;
      this.$emit("select", row);
    },

    resetHandle(filter) {
      this.filter = filter;
    },
  },
};
</script>
